<template>
  <div class="mt-4">
    <div v-if="loadingAcceptInvite" class="mt-4 d-flex flex-column justify-content-center align-items-center">
      <span class="mt-2">{{ $t('accept-invite.loading.message') }}...</span>
      <CSpinner class="my-3" color="primary" />
    </div>
    <div class="text-center d-flex flex-column" v-if="acceptInviteError">
      <span class="mb-2 text-danger font-weight-bold">{{ errorMessage }}</span>
      <div>
        <CButton class="btn-link" @click="redirectToOrganizationSelection"> {{ $t('accept-invite.error.redirect-btn') }} </CButton>
      </div>
    </div>
  </div>
</template>

<script>
import services from '@/services'

export default {
  data() {
    return {
      loadingAcceptInvite: false,
      acceptInviteError: false,
      errorMessage: undefined,
    }
  },
  mounted() {
    if (this.$route.params.inviteId) {
      this.acceptInvite()
    }
  },
  methods: {
    async acceptInvite() {
      try {
        this.loadingAcceptInvite = true
        await services.acceptInvite(this.$route.params.inviteId)
        this.$router.push({ name: 'home' })
      } catch (error) {
        this.acceptInviteError = true
        const errorTranslationRef = error.response.data.message ? `general.errors.${error.response.data.message}` : 'error.codes.DEFAULT'
        this.errorMessage = this.$t(errorTranslationRef)
      } finally {
        this.loadingAcceptInvite = false
      }
    },
    redirectToOrganizationSelection() {
      this.$router.push({ name: 'OrganizationSelection' })
    },
  },
}
</script>

<style></style>
